<p>
  promotion works!
</p>
